module.exports = __webpack_public_path__ + "img/124.22aa821d.png";